var _path, _rect, _rect2, _rect3, _rect4, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRarityEpic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7798 4.97407L17.2961 3.11688C15.8259 2.50792 14.1741 2.50792 12.7039 3.11688L8.22024 4.97407C6.75008 5.58304 5.58203 6.75108 4.97307 8.22125L3.11587 12.7049C2.50691 14.1751 2.50691 15.827 3.11587 17.2971L4.97307 21.7808C5.58203 23.251 6.75008 24.419 8.22024 25.028L12.7039 26.8852C14.1741 27.4941 15.8259 27.4941 17.2961 26.8852L21.7798 25.028C23.2499 24.419 24.418 23.251 25.027 21.7808L26.8842 17.2971C27.4931 15.827 27.4931 14.1751 26.8842 12.7049L25.027 8.22125C24.418 6.75108 23.2499 5.58304 21.7798 4.97407ZM18.0615 1.26912C16.1013 0.457168 13.8988 0.457168 11.9385 1.26912L7.45488 3.12632C5.49465 3.93827 3.93726 5.49566 3.12531 7.45588L1.26811 11.9396C0.456161 13.8998 0.456161 16.1023 1.26811 18.0625L3.12531 22.5462C3.93726 24.5064 5.49465 26.0638 7.45488 26.8757L11.9385 28.7329C13.8988 29.5449 16.1013 29.5449 18.0615 28.7329L22.5451 26.8757C24.5054 26.0638 26.0628 24.5064 26.8747 22.5462L28.7319 18.0625C29.5439 16.1023 29.5439 13.8998 28.7319 11.9396L26.8747 7.45588C26.0628 5.49566 24.5054 3.93827 22.5451 3.12631L18.0615 1.26912Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 2,
    width: 2,
    height: 4,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 24,
    width: 2,
    height: 4,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 2,
    width: 2,
    height: 4,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 24,
    width: 2,
    height: 4,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 20.999V9.20703H18.712V11.335H12.696V13.863H18.152V15.911H12.696V18.871H18.712V20.999H10.2Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRarityEpic);
export default __webpack_public_path__ + "static/media/rarity-epic.86d9a8ca.svg";
export { ForwardRef as ReactComponent };